import { Link } from "react-router-dom";
import { formatUrl } from "../exports/functions";
import useMobile from "../hooks/useMobile";
import sciever from "../images/logo/ScieverInc.jpg";
import useTab from "../hooks/useTab";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";

const FooterThree = () => {
  const { companyDetailsData } = useCompanyDetailsContext();
  const date = new Date();
  const yyyy = date.getFullYear();
  const mobile = useMobile();
  const tab = useTab();
  return (
    <footer className="footer bg-neutral-900 position-relative z-1">
      {/* <img
        src="assets/images/shapes/shape2.png"
        alt=""
        className="shape five animation-scalation"
      /> */}
      {/* <img
        src="assets/images/shapes/shape6.png"
        alt=""
        className="shape one animation-scalation"
      /> */}
      <div className={`${!mobile && !tab ? "pt-120 pb-90" : "py-120"}`}>
        <div className="container container-two">
          <div className="row gy-5">
            <div
              className="col-lg-5 col-sm-5 col-xs-6"
              data-aos="fade-up"
              data-aos-duration={1200}
              style={{ height: "220px" }}
            >
              <div
                className="footer-item"
                style={{
                  position: "absolute",
                  width: mobile ? "calc(100dvw - 24px)" : "25%",
                  top: 0,
                }}
              >
                <img
                  src={
                    companyDetailsData[0]?.footer_image[0]?.media?.url &&
                    `${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.footer_image[0]?.media?.url}`
                  }
                  alt="footer-img"
                  // className="rounded-12"
                  style={{
                    maxWidth: "100%",
                    borderRadius: "0 0 0.75rem 0.75rem",
                  }}
                />
                <p
                  className="text-white"
                  style={{ marginTop: "10px" }}
                  dangerouslySetInnerHTML={{
                    __html: companyDetailsData[0]?.footer_description,
                  }}
                />
              </div>
            </div>
            {!mobile && (
              <div
                className="col-lg-1 col-sm-1 col-xs-0"
                data-aos="fade-up"
                data-aos-duration={1200}
              ></div>
            )}
            <div
              className="col-lg-3 col-sm-3 col-xs-6"
              data-aos="fade-up"
              data-aos-duration={600}
            >
              <div className="footer-item">
                {/* <h4 className="footer-item__title fw-medium text-white mb-32">
                  Quick Link
                </h4> */}
                <ul className="footer-menu">
                  <li className="mb-16">
                    <Link
                      to="/programs"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      Academic
                    </Link>
                  </li>
                  <li className="mb-16">
                    <Link
                      to="/facilities"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      Student Life
                    </Link>
                  </li>
                  <li className="mb-16">
                    <Link
                      to="/gallery"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      Gallery
                    </Link>
                  </li>
                  <li className="mb-16">
                    <Link
                      to="/ega"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      EGA
                    </Link>
                  </li>
                  <li className="mb-16">
                    <Link
                      to="/contact"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      Contact
                    </Link>
                  </li>
                  <li className="mb-0">
                    <Link
                      to="/admission"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      Enroll
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            {/* <div
              className='col-lg-3 col-sm-6 col-xs-6'
              data-aos='fade-up'
              data-aos-duration={800}
            >
              <div className='footer-item'>
                <h4 className='footer-item__title fw-medium text-white mb-32'>
                  Category
                </h4>
                <ul className='footer-menu'>
                  <li className='mb-16'>
                    <Link
                      to='/courses'
                      className='text-white hover-text-main-600 hover-text-decoration-underline'
                    >
                      UI/UX Design
                    </Link>
                  </li>
                  <li className='mb-16'>
                    <Link
                      to='/courses'
                      className='text-white hover-text-main-600 hover-text-decoration-underline'
                    >
                      Web Development
                    </Link>
                  </li>
                  <li className='mb-16'>
                    <Link
                      to='/courses'
                      className='text-white hover-text-main-600 hover-text-decoration-underline'
                    >
                      Python Development
                    </Link>
                  </li>
                  <li className='mb-16'>
                    <Link
                      to='/courses'
                      className='text-white hover-text-main-600 hover-text-decoration-underline'
                    >
                      Digital Marketing
                    </Link>
                  </li>
                  <li className='mb-16'>
                    <Link
                      to='/courses'
                      className='text-white hover-text-main-600 hover-text-decoration-underline'
                    >
                      Graphic Design
                    </Link>
                  </li>
                </ul>
              </div>
            </div> */}
            <div
              className="col-lg-3 col-sm-3 col-xs-6"
              data-aos="fade-up"
              data-aos-duration={800}
            >
              <div className="footer-item">
                {/* <h4 className="footer-item__title fw-medium text-white mb-32">
                  Contact Us
                </h4> */}
                <div className="flex-align gap-20 mb-24">
                  <span className="icon d-flex text-32 text-main-600">
                    <i className="ph ph-phone" />
                  </span>
                  <div className="">
                    <a
                      href={`tel:${companyDetailsData[0]?.phone_number1}`}
                      className="text-white d-block hover-text-main-600 mb-4"
                    >
                      {companyDetailsData[0]?.phone_number1}
                    </a>
                    <a
                      href={`tel:${companyDetailsData[0]?.phone_number2}`}
                      className="text-white d-block hover-text-main-600 mb-4"
                    >
                      {companyDetailsData[0]?.phone_number2}
                    </a>
                  </div>
                </div>
                <div className="flex-align gap-20 mb-24" id="contactinfo">
                  <span className="icon d-flex text-32 text-main-600">
                    <i className="ph ph-envelope-open" />
                  </span>
                  <div className="">
                    <a
                      href={`mailto:${companyDetailsData[0]?.email}`}
                      className="text-white d-block hover-text-main-600 mb-4"
                    >
                      {companyDetailsData[0]?.email}
                    </a>
                    <a
                      href={`mailto:${companyDetailsData[0]?.secondary_email}`}
                      className="text-white d-block hover-text-main-600 mb-4"
                    >
                      {companyDetailsData[0]?.secondary_email}
                    </a>
                  </div>
                </div>
                <div className="flex-align gap-20 mb-24">
                  <span className="icon d-flex text-32 text-main-600">
                    <i className="ph ph-map-pin" />
                  </span>
                  <div className="">
                    <a
                      href={companyDetailsData[0]?.map}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white d-block hover-text-main-600 mb-4"
                    >
                      {companyDetailsData[0]?.company_address}
                    </a>
                    {/* <span className="text-white d-block mb-0">
                      8745 doer Dr.
                    </span> */}
                  </div>
                </div>
                <div className="flex-align gap-20 mb-0">
                  <span className="icon d-flex text-32 text-main-600">
                    <i className="ph ph-clock" />
                  </span>
                  <div className="">
                    <span className="text-white d-block mb-4">
                      {companyDetailsData[0]?.school_hours?.split(",")[0]}
                      <br />
                      {companyDetailsData[0]?.school_hours
                        ?.split(",")[1]
                        ?.trim()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        {/* bottom Footer */}
        <div className="bottom-footer border-top border-dashed border-neutral-600 border-0 py-32">
          <div
            className="container container-two"
            style={{ paddingRight: "unset", paddingLeft: "unset" }}
          >
            <div className="bottom-footer__inner flex-between gap-16 flex-wrap">
              <div className="footer-item__logo mb-0" data-aos="zoom-in-right">
                <Link to="/">
                  {" "}
                  <img
                    src={
                      companyDetailsData[0]?.primary_logo_inverse[0]?.media
                        ?.url &&
                      `${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.primary_logo_inverse[0]?.media?.url}`
                    }
                    alt="Logo"
                  />
                </Link>
              </div>
              <p className="text-white fw-normal" data-aos="zoom-in">
                {" "}
                Copyright © {yyyy}{" "}
                <span className="fw-semibold">
                  {" "}
                  <a href="/" style={{ color: "#ffffff" }}>
                    Evergreen Academy
                  </a>{" "}
                </span>{" "}
                - Powered by{" "}
                <a
                  href="https://www.scieverinc.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fw-semibold f-flex gap-10"
                  style={{ color: "#ffffff" }}
                >
                  <img
                    src={sciever}
                    alt="sciever-img"
                    style={{ margin: "0px 4px 5px 0px" }}
                  />
                  <span>Sciever Inc.</span>
                </a>
              </p>
              <ul
                className="social-list flex-align gap-24"
                data-aos="zoom-in-left"
              >
                {companyDetailsData[0]?.facebook_link && (
                  <li className="social-list__item">
                    <Link
                      to={formatUrl(companyDetailsData[0]?.facebook_link)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white text-2xl hover-text-main-two-600"
                    >
                      <i className="ph-bold ph-facebook-logo" />
                    </Link>
                  </li>
                )}
                {companyDetailsData[0]?.twitterx_link && (
                  <li className="social-list__item">
                    <Link
                      to={formatUrl(companyDetailsData[0]?.twitterx_link)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white text-2xl hover-text-main-two-600"
                    >
                      <i className="ph-bold ph-x-logo" />
                    </Link>
                  </li>
                )}
                {companyDetailsData[0]?.instagram_link && (
                  <li className="social-list__item">
                    <Link
                      to={formatUrl(companyDetailsData[0]?.instagram_link)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white text-2xl hover-text-main-two-600"
                    >
                      <i className="ph-bold ph-instagram-logo" />
                    </Link>
                  </li>
                )}
                {/* <li className="social-list__item">
                  <Link
                    to="https://www.pinterest.com"
                    className="text-white text-2xl hover-text-main-two-600"
                  >
                    <i className="ph-bold ph-pinterest-logo" />
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterThree;
